export default __webpack_public_path__ + "static/media/76_mobile.2f9fe902.jpg";